import styled from "styled-components";
import { ICardContent } from "./CardContent.interface";
import { sm, md } from "../../../AppTheme.styled";

const StyledCardContent = styled.div<ICardContent>`
  color: ${({ theme }) => theme.palette.neutral1};
  text-decoration: none;
  text-align: ${(props) => (props.textAlign ? props.textAlign : "initial")};
  padding: ${(props) => (props.padding ? props.padding : "17px 15px 15px")};
`;

export default StyledCardContent;
